import { render, staticRenderFns } from "./WayToPayCatalog.vue?vue&type=template&id=0d6be4d6"
import script from "./WayToPayCatalog.vue?vue&type=script&lang=js"
export * from "./WayToPayCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d6be4d6')) {
      api.createRecord('0d6be4d6', component.options)
    } else {
      api.reload('0d6be4d6', component.options)
    }
    module.hot.accept("./WayToPayCatalog.vue?vue&type=template&id=0d6be4d6", function () {
      api.rerender('0d6be4d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/WayToPayCatalog.vue"
export default component.exports